/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lang-is-active[_ngcontent-%COMP%]{background-color:#ffeae6}.active-language[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.active-language[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:15px}.active-language[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding-left:10px}"];
export { styles as styles };
